import { GetAboutusInfo, getAboutusInfo } from './aboutUs-info'
import { GetCooperationPageData, getCooperationPageData } from './cooperation-page'
import { GetHomePageContentRes, getHomePageContents } from './home-page-content'
import { GetLeasingInfo, getLeasingInfo } from './leasing-info'
import { getHbbWifi, getCityList, getQuarterList, getDistrictList, getTravelPoint } from './network-coverage'
import { GetCityList, GetDistrictList, GetHbbWifi, GetQuarterList, GetTravelPoint } from './network-coverage/types'
import { GetNewsDetailsRes, GetNewsRes, getNews, getNewsDetails } from './news'
import { GetPreorder, getPreOrder } from './preorder'
import { getSDGPageData } from './sdg-page'
import { GetSDGPageRes } from './sdg-page/types'
import { Search, search } from './search'
import { getServiceBranches } from './service-branches'
import { GetServiceBranches } from './service-branches/types'

import { getServiceCategories, getServiceList, getSingleService } from './service-menu'
import { GetServiceCategories, GetServiceList, GetSingleService } from './service-menu/types'
import { GetTradeInRes, getTradeInInfo } from './trade-in'
import { GetRoaming, getRoaming } from './roaming'
import { getDigitalConsentData, GetDigitalConsentData } from './digital-consent'
import { GetOnlineShops, getOnlineShops } from './onlineshop-banner'

type UseCmsApi = () => {
  getTradeIn: () => Promise<GetTradeInRes>
  getHomePageContents: () => Promise<GetHomePageContentRes>
  getNews: () => Promise<GetNewsRes>
  getNewsDetails: (id: string) => Promise<GetNewsDetailsRes>
  getSDGPageData: () => Promise<GetSDGPageRes>
  getServiceBranches: GetServiceBranches
  getCityList: GetCityList
  getHbbWifi: GetHbbWifi
  getDistrictList: GetDistrictList
  getQuarterList: GetQuarterList
  getTravelPoint: GetTravelPoint
  getServiceCategories: GetServiceCategories
  getServiceList: GetServiceList
  getSingleService: GetSingleService
  getLeasingInfo: GetLeasingInfo
  getAboutusInfo: GetAboutusInfo
  getPreOrder: GetPreorder
  search: Search
  getCooperationPageData: GetCooperationPageData
  getRoaming: GetRoaming
  getDigitalConsentData: GetDigitalConsentData
  getOnlineShops: GetOnlineShops
}

export const useCmsApi: UseCmsApi = () => {
  return {
    getTradeIn: async () => {
      return await getTradeInInfo()
    },
    getHomePageContents: async () => {
      return await getHomePageContents()
    },
    getNews: async () => {
      return await getNews()
    },
    getNewsDetails: async (id) => {
      return await getNewsDetails(id)
    },
    getSDGPageData: async () => {
      return await getSDGPageData()
    },
    getServiceBranches: async (district) => {
      return await getServiceBranches(district)
    },
    getCityList: async () => {
      return await getCityList()
    },
    getDistrictList: async (zipcode) => {
      return await getDistrictList(zipcode)
    },
    getQuarterList: async (zipcode) => {
      return await getQuarterList(zipcode)
    },
    getTravelPoint: async (zipcodes) => {
      return await getTravelPoint(zipcodes)
    },
    getHbbWifi: async () => {
      return await getHbbWifi()
    },
    getServiceCategories: async () => {
      return await getServiceCategories()
    },
    getServiceList: async (id) => {
      return await getServiceList(id)
    },
    getSingleService: async (id) => {
      return await getSingleService(id)
    },
    getLeasingInfo: async (id) => {
      return await getLeasingInfo(id)
    },
    getAboutusInfo: async () => {
      return await getAboutusInfo()
    },
    getPreOrder: async (id) => {
      return await getPreOrder(id)
    },
    search: async (key) => {
      return await search(key)
    },
    getCooperationPageData: async () => {
      return await getCooperationPageData()
    },
    getRoaming: async () => {
      return await getRoaming()
    },
    getDigitalConsentData: async () => {
      return await getDigitalConsentData()
    },
    getOnlineShops: async () => {
      return await getOnlineShops()
    }
  }
}
